//-----------------------------------------------------------------------------
// Michael B. Gale's Website
// Copyright (c) 2022 Michael B. Gale (hello@michael-gale.co.uk)
//-----------------------------------------------------------------------------

import type { GatsbyBrowser } from "gatsby";
import wrapWithLayout from "./wrap-page";
import './src/styles/global.scss';
import smoothscroll from "smoothscroll-polyfill";

//-----------------------------------------------------------------------------

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = wrapWithLayout;

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
    smoothscroll.polyfill();
}

//-----------------------------------------------------------------------------
